<template>
  <roe-error-message :field="design.service_requirement_sync">
    <roe-radio-input
      v-model="design.$model.service_requirement_sync"
      @change="onChange()"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";

export default {
  name: "RoeServiceRequirementSyncRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    onChange() {
      if (+this.design.$model.service_requirement_sync === 1) {
        this.design.$model.service_requirement_match_measurement_number = this.design.$model.service_requirement_measurement_number;
      }
    }
  }
};
</script>
